import moment from "moment/moment";
import {isEmpty} from "../../../../_helpers/commonFunctions";

export const percentageTableFormatter = (obj, fixedAssetsSettings) => {
    // THIS FUNCTION EXISTS IN BACKEND TOO
    if (obj.category) {
        const matchingCategory = fixedAssetsSettings.categories.find((el) => el._id === obj.category);
        if (matchingCategory) {
            const newPercTable = [];
            const unitPrice = (+obj.acquisitionCost / (+obj.quantity || 1));
            const matchingPercentages = matchingCategory.percentageTable.filter((el) =>
                (isEmpty(el.amountFrom) && isEmpty(el.amountTo))
                || (el.amountFrom === 0 && el.amountTo === 0)
                || (unitPrice >= el.amountFrom && unitPrice <= el.amountTo)
                || (unitPrice >= el.amountFrom && el.amountTo === 0)
            );
            for (const perc of matchingPercentages) {
                const newObj = {
                    percentage: perc.percentage,
                    dateFrom: "",
                    dateTo: "",
                }
                if (moment(obj.dateFrom).isValid()) {
                    const momentObj = moment(obj.dateFrom);
                    if (perc.monthFrom) {
                        const subtract = +perc.monthFrom - (matchingCategory.startingPeriod === "currentMonth" ? 1 : 0);
                        newObj.dateFrom = momentObj.clone().add(subtract, "month").startOf("month").hour(10).toDate();
                    } else {
                        newObj.dateFrom = momentObj.clone().hour(10).toDate();
                    }
                    if (perc.monthTo) {
                        const subtract = +perc.monthTo - (matchingCategory.startingPeriod === "currentMonth" ? 1 : 0);
                        newObj.dateTo = momentObj.clone().add(subtract, "month").endOf("month").hour(10).toDate();
                    }
                }
                newPercTable.push(newObj);
            }
            obj.percentageTable = newPercTable;
        }
    }
    return obj;
}

export const getAcquisitionCost = (obj) => {
    let value = 0;
    try {
        value += +obj.acquisitionCost;
        if (obj?.additionalImprovements?.length > 0) {
            value += obj.additionalImprovements.reduce((sum, obj) => sum + obj.amount, 0);
        }
    } catch (e) {
        return 0;
    }
    return value || 0;
}

export const getDevaluation = (obj, upToDate, calculationBy = "daily") => { // Devaluation = depreciation
    /*
    obj is fixed asset object, upToDate should be date object, calculationBy = daily / monthly
    Returns object like
    {
        devaluation: number; the devaluation that it should have by now
        devaluationAfterBalance: number; the devaluation after the current balance of the fixed asset
    }
     */
    try {
        const startDate = moment(obj.dateFrom);
        const startingPeriod = obj.startingPeriod;
        let devaluationStartingDate;
        if (startingPeriod === "currentMonth") {
            devaluationStartingDate = startDate.clone().startOf("month").hour(9);
        } else if (startingPeriod === "nextMonth") {
            devaluationStartingDate = startDate.clone().add(1, "month").startOf("month").hour(9);
        }
        const upTo = moment(upToDate).hour(10);
        const periodAmounts = {} // Will have "DD/MM/YYYY" : amount. We are going to sum them in the end.
        let lastAcquisitionCost = obj.acquisitionCost;
        if (calculationBy === "daily") {
            for (let dayI = devaluationStartingDate.clone(); dayI <= upTo; dayI.add(1, "day")) {
                const matchingPercentage = obj.percentageTable.find((el) =>
                    (isEmpty(el.dateFrom) && isEmpty(el.dateTo)) ||
                    (moment(el.dateFrom) <= dayI && isEmpty(el.dateTo)) ||
                    (moment(el.dateFrom) <= dayI && moment(el.dateTo) >= dayI)
                );
                if (matchingPercentage) {
                    let acquisitionCost = obj.acquisitionCost;
                    if (obj?.additionalImprovements?.length > 0) {
                        obj.additionalImprovements.forEach((ai) => {
                            if (moment(ai.date) < dayI) acquisitionCost += ai.amount;
                        })
                    }
                    lastAcquisitionCost = acquisitionCost; // Save last acquisition with the additional improvements as final acquisition cost
                    if (matchingPercentage.percentage === 100) { // Special case for 100% depreciation
                        periodAmounts[dayI.format("DD/MM/YYYY")] = +Number(acquisitionCost).toFixed(2);
                        break;
                    } else {
                        periodAmounts[dayI.format("DD/MM/YYYY")] = +Number(acquisitionCost * ((+matchingPercentage.percentage / 365) / 100)).toFixed(4);
                    }
                } else {
                    periodAmounts[dayI.format("DD/MM/YYYY")] = 0;
                }
            }
        } else if (calculationBy === "monthly") {
            for (let monthI = devaluationStartingDate.clone(); monthI <= upTo; monthI.add(1, "month")) {
                const matchingPercentage = obj.percentageTable.find((el) =>
                    (isEmpty(el.dateFrom) && isEmpty(el.dateTo)) ||
                    (moment(el.dateFrom) <= monthI && isEmpty(el.dateTo)) ||
                    (moment(el.dateFrom) <= monthI && moment(el.dateTo) >= monthI)
                );
                if (matchingPercentage) {
                    let acquisitionCost = obj.acquisitionCost;
                    if (obj?.additionalImprovements?.length > 0) {
                        obj.additionalImprovements.forEach((ai) => {
                            if (moment(ai.date) < monthI) acquisitionCost += ai.amount;
                        })
                    }
                    lastAcquisitionCost = acquisitionCost; // Save last acquisition with the additional improvements as final acquisition cost
                    if (matchingPercentage.percentage === 100) { // Special case for 100% depreciation
                        periodAmounts[monthI.format("MM/YYYY")] = +Number(acquisitionCost).toFixed(2);
                        break;
                    } else {
                        periodAmounts[monthI.format("MM/YYYY")] = +Number(acquisitionCost * ((+matchingPercentage.percentage / 12) / 100)).toFixed(4);
                    }
                } else {
                    periodAmounts[monthI.format("MM/YYYY")] = 0;
                }
            }
        }
        let totalDevaluation = 0; // How much the devaluation should be
        for (const am of Object.values(periodAmounts)) totalDevaluation += am;
        totalDevaluation = Math.min(+Number(totalDevaluation).toFixed(2), lastAcquisitionCost);

        const afterBalance = totalDevaluation - (obj.accumulatedDepreciation || 0);

        return {
            devaluation: +Number(totalDevaluation).toFixed(2),
            devaluationAfterBalance: +Number(afterBalance).toFixed(2),
        }
    } catch (e) {
        return {
            devaluation: 0,
            devaluationAfterBalance: 0,
        }
    }
}

export const correctFixedAssetRecordRow = (obj) => { // 0.01 stuff
    try {
        obj.balance = +Number(obj.acquisitionCost - obj.accumulatedDepreciation - obj.amount).toFixed(2);
        if (obj.balance === 0 && obj.amount > 0.01) {
            obj.balance = 0.01;
            obj.amount = +Number(obj.amount - 0.01).toFixed(2);
        }
    } catch {}
    return obj;
}

export const DISABLED_FIXED_ASSET_CATEGORIES = [
    "ΚΤΙΡΙΑ ΚΑΙ ΕΓΚΑΤΑΣΤΑΣΕΙΣ",
    "ΜΗΧΑΝΗΜΑΤΑ",
    "ΦΟΡΤΗΓΑ - ΡΥΜΟΥΛΚΕΣ - ΜΕΣΑ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ",
    "ΑΥΛΑ ΣΤΟΙΧΕΙΑ ΚΑΙ ΛΟΙΠΑ ΔΙΚΑΙΩΜΑΤΑ",
    "ΕΞΟΠΛΙΣΜΟΣ Η/Υ",
    "ΛΟΙΠΑ ΠΑΓΙΑ",
    "ΓΗΠΕΔΑ - ΟΙΚΟΠΕΔΑ",
    "ΤΕΧΝΙΚΕΣ ΕΓΚΑΤΑΣΤΑΣΕΙΣ",
    "ΕΡΓΑΛΕΙΑ",
    "ΛOIΠOΣ MHXANOΛOΓIKOΣ EΞOΠΛIΣMOΣ",
    "ΕΠΙΒΑΤΗΓΑ ΑΥΤΟΚΙΝΗΤΑ Ι.Χ. - ΛΕΩΦΟΡΙΑ",
    "ΕΠΙΒΑΤΗΓΑ ΑΥΤΟΚΙΝΗΤΑ Ι.Χ. - ΛΕΩΦΟΡΕΙΑ", // Correction
    "ΣΙΔΗΡΟΔΡΟΜΙΚΑ ΟΧΗΜΑΤΑ",
    "ΠΛΩΤΑ ΜΕΣΑ - ΣΚΑΦΗ",
    "ΕΝΑΕΡΙΑ ΜΕΣΑ - ΑΕΡΟΠΛΑΝΑ",
    "ΜΕΣΑ ΕΣΩΤΕΡΙΚΩΝ ΜΕΤΑΦΟΡΩΝ",
    "ΕΠΙΠΛΑ",
    "ΣΚΕΥΗ - ΕΙΔΗ ΕΣΤΙΑΣΗΣ",
    "ΜΗΧΑΝΕΣ ΓΡΑΦΕΙΩΝ",
    "ΕΠΙΣΤΗΜΟΝΙΚΑ ΟΡΓΑΝΑ",
    "ΕΞΟΠΛΙΣΜΟΣ ΤΗΛΕΠΟΙΚΟΙΝΩΝΙΩΝ",
    "ΛΟΓΙΣΜΙΚΑ ΠΡΟΓΡΑΜΜΑΤΑ",
    "ΑΜΙΓΩΣ ΗΛΕΚΤΡΙΚΑ ΕΠΙΒΑΤΗΓΑ ΟΧΗΜΑΤΑ",
    "PLUG-IN HYBRID ΕΠΙΒΑΤΗΓΑ ΟΧΗΜΑΤΑ",
];
